"use client";

import React from "react";

import { iconColor } from "../colors";
import { createSVGIcon } from "../createSVGIcon";
import { iconCls } from "../tracking";

/**
 * @figma designed by Brooklyn Brown, Gabe Kelley, Nick Howland (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5302%3A977))
 * @lastsynced 2026-10-29T13:53:55.407Z
 * @trackcomponent
 * @optimized using svgo:^3.3.4
 */
export const RewindClock = createSVGIcon(
  <path
    d="M12 6v6h4.286M1.71 7.714C3.391 3.688 7.365.857 12.001.857 18.153.857 23.142 5.846 23.142 12S18.154 23.143 12 23.143c-5.269 0-9.684-3.657-10.845-8.571M.857 3.428v4.285h4.286"
    strokeLinecap="round"
    strokeLinejoin="round"
    stroke="currentColor"
  />,
  "RewindClock",
  {
    color: iconColor.primary,
    fill: "none",
    viewBox: "0 0 24 24",
    className: iconCls(),
  } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
